import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@mui/material'
import React, { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import SnackBarUI from '../../../comman/SnackBarUI'
// import { getCategoryAction } from '../../../redux/toolkit/category/getCategory'
import PropTypes from 'prop-types';
import { deleteFAQAction } from '../../../redux/toolkit/publisher/support/deleteFAQ'
import { getFAQAction } from '../../../redux/toolkit/publisher/support/getFAQs'

export default function DeleteFAQ({ id, state, setState }) {
    // state
    const dispatch = useDispatch()
    const deleteFAQ = useSelector(state => state.deleteFAQ)
    const { status, message } = deleteFAQ

    const [snack, setSnack] = useState(false)

    // fn
    const handleClose = () => {
        setState(false)
    }

    const delCatHandle = async () => {
        await dispatch(deleteFAQAction({id:id}))
        await dispatch(getFAQAction({ is_deleted: false }))
        setSnack(true)
        setState(false)
    }

    return (
        <>
            <Dialog open={state} onClose={handleClose}>
                <DialogTitle>Deleting request !</DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                        Are you sure you want to delete the selected item ?
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={delCatHandle} autoFocus> Agree</Button>
                    <Button onClick={handleClose}>Disagree</Button>
                </DialogActions>
            </Dialog>


            <SnackBarUI state={snack} setState={setSnack} status={status} message={message} />
        </>

    )
}



DeleteFAQ.propTypes = {
    id: PropTypes.string,
    state: PropTypes.any,
    setState: PropTypes.any
};
